// extracted by mini-css-extract-plugin
export default {"dashboard":"blog_dashboard__wgAPv","hero":"blog_hero__iYQmQ","surface":"blog_surface__b+nJE","content":"blog_content__b+2VE","date":"blog_date__aWUPg"};